import { getRecaptchaToken } from '../../helpers/loadRecaptcha';

for (const form of document.querySelectorAll('form[data-recaptcha-form]')) {
	let submitting = false;
	const error = form.querySelector('[data-recaptcha-error]');

	form.addEventListener('submit', (event) => {
		event.preventDefault();
		if (submitting) return;
		submitting = true;
		error.hidden = true;
		form.querySelectorAll('[name="g-recaptcha-token"]').forEach((input) => input.remove());
		getRecaptchaToken().then((token) => {
			if (token) {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = 'g-recaptcha-token';
				input.value = token;
				form.appendChild(input);
			}
			form.submit();
		}).catch(() => {
			submitting = false;
			error.hidden = false;
			const button = form.querySelector('button[type="submit"]');
			button.disabled = false;
			button.classList.remove('loading');
		});
	});
}
